/**
 * How long a page waits between heartbeats to the discovery server.
 *
 * The server sends the rate in its welcome (20 s) and drops a peer it has not
 * heard from for 60 s (localDiscovery groups.mjs, removeStalePeers), checking
 * once a minute. Dropping a peer unregisters its routes; the peer's next
 * heartbeat puts it back in the group, but its routes return only when route
 * drift is confirmed, so in between it is listed and does not answer.
 *
 * A hidden page used to back off to 60 s — exactly the server's limit — so any
 * lateness (timer throttling in a background tab, a busy main thread) dropped
 * it. Seen at the Simtable office on 2026-10-26: a Window on a mini PC whose
 * display slept was dropped about 55 times in a day, the GeoCamera tab on the
 * same machine and network 7 times. A hidden page now waits half as long
 * again as the server asks, which still saves a third of the wake-ups and
 * leaves two heartbeats inside every window the server allows.
 */

export const HIDDEN_FACTOR = 1.5

/**
 * @param {number} rate - the server's requested heartbeat rate, in ms
 * @param {boolean} hidden - whether the page is hidden
 * @returns {number} ms until the next heartbeat
 */
export function heartbeatDelay(rate, hidden) {
    return hidden ? Math.round(rate * HIDDEN_FACTOR) : rate
}
